import { PlanOption } from "@/features/planSelection/models/PlanOption";
import { DomainFlowState } from "../types/DomainFlowState";

export interface SummaryItemProps {
    state: DomainFlowState;
    domainName: string;
    price: number;
}

export class DomainSummaryModel {
    static create({ state, domainName, price }: SummaryItemProps): PlanOption | null {
        if (!domainName || state === "none") return null;

        switch (state) {
            case "available":
                return PlanOption.create({
                    id: "domain-registration",
                    displayName: `Domain: ${domainName}`,
                    prices: { yearly: 0 },
                    features: ["1yr .nl registration + SSL"],
                });

            case "taken-own-manage":
                return PlanOption.create({
                    id: "domain-transfer",
                    displayName: `Transfer Domain: ${domainName}`,
                    prices: { yearly: 0 },
                    features: ["Includes DNS/email setup + security"],
                });

            case "taken-own-keep":
                return PlanOption.create({
                    id: "external-domain",
                    displayName: `Use Existing Domain: ${domainName}`,
                    prices: { oneTime: 0 },
                    features: [`${domainName} (user-managed)`],
                });

            case "deferred":
            case "deferred-with-consultation":
                return PlanOption.create({
                    id: "no-domain",
                    displayName: state === "deferred-with-consultation"
                        ? "Domain Consultation"
                        : "No Domain Selected",
                    prices: { oneTime: 0 },
                    features: state === "deferred-with-consultation"
                        ? ["Add domain later + consultation"]
                        : ["You can add one later"],
                });

            default:
                return null;
        }
    }
}